export { default as useGetBulletinRecipients } from "./GetBulletinRecipients";
